import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProvince } from 'src/types';

export interface IAreaStoreState {
  list: IProvince[];
  active: string;
  activeName: string;
}

const initialState: IAreaStoreState = {
  list: [],
  active: '',
  activeName: '',
};

const areaSlice = createSlice({
  name: 'area',
  initialState,
  reducers: {
    setListArea: (state, { payload }: PayloadAction<IProvince[]>) => ({ ...state, list: payload }),
    setAreaActive: (state, { payload }: PayloadAction<{ active: string; activeName: string }>) => ({
      ...state,
      active: payload.active,
      activeName: payload.activeName,
    }),
  },
});

export const { setListArea, setAreaActive } = areaSlice.actions;

export default areaSlice.reducer;
